import { render, staticRenderFns } from "./CustomFieldSourceBadge.vue?vue&type=template&id=7902ce8e"
import script from "./CustomFieldSourceBadge.vue?vue&type=script&lang=js"
export * from "./CustomFieldSourceBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports